import { useFormContext, useWatch } from "react-hook-form";
import ActionBuildingDetailsContainer from "./ActionBuildingDetailsContainer";
import ActionBuildingTypesDetailsContainer from "./ActionBuildingTypesContainer";
import ActionTypesDetailsContainer from "./ActionTypesDetailsContainer";

import { Button } from "@dune/ui";
import { Minus, Plus } from "lucide-react";
import ActionsSyndicSelectorContainer from "./ActionsSyndicSelectorContainer";
import RenovationOrExtensionDetailsContainer from "./RenovationOrExtensionDetailsContainer";
import SocialLandlordRentalDetailsContainer from "./SocialLandlordRentalDetailsContainer";
import IfSyndicOptionsContainer from "./IfSyndicOptionsContainer";
import BuildingUsageContainer from "./BuildingUsageContainer";
import { useMemo } from "react";
import { useMe } from "../../../api/queries/users.queries";
import { RoleEnum } from "../../../../../../packages/vars/src";

const ActionsDetailsContainer = ({
	hideComplementaryButton = false,
	isGFA = false,
	currentUserIsClient = false,
	clientIsSyndic = false,
}: {
	hideComplementaryButton?: boolean;
	isGFA?: boolean;
	currentUserIsClient?: boolean;
	clientIsSyndic?: boolean;
}) => {
	const { me } = useMe();
	const currentUserIsSyndic = useMemo(
		() => me?.role === RoleEnum.SYNDIC,
		[me?.role],
	);
	const { control, setValue } = useFormContext();
	const actionsValue = useWatch({ control, name: "actions" });
	const commonPartsValue =
		actionsValue.types.includes("SYNDIC") &&
		actionsValue.buildingType === "COMMON_PARTS";
	const privateWorkValue =
		actionsValue.types.includes("SYNDIC") &&
		actionsValue.buildingType === "PRIVATE_WORK";
	return (
		<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-8">
			<div className="flex flex-col gap-4">
				{(currentUserIsSyndic || clientIsSyndic) && (
					<IfSyndicOptionsContainer disabled={currentUserIsSyndic} />
				)}
				{!currentUserIsSyndic && !clientIsSyndic && (
					<ActionTypesDetailsContainer />
				)}
				{!currentUserIsSyndic &&
					!clientIsSyndic &&
					actionsValue.types.length > 0 && (
						<ActionBuildingTypesDetailsContainer isGFA={isGFA} />
					)}
				{actionsValue?.buildingType && (
					<>
						{!hideComplementaryButton && (
							<Button
								onClick={() => {
									setValue("actions", {
										...actionsValue,
										hasComplementaryActions:
											!actionsValue.hasComplementaryActions,
										complementaryActions: !actionsValue.hasComplementaryActions
											? {
													types: [],
													buildingType: null,
												}
											: undefined,
									});
								}}
								variant="none"
								size="none"
								className="self-start"
								type="button"
							>
								{!actionsValue.hasComplementaryActions ? (
									<div className="flex flex-row items-center gap-2 font-medium text-sm text-gray-500">
										<Plus /> compléter l'opération (affiche en dessous)
									</div>
								) : (
									<div className="flex flex-row items-center gap-2 font-medium text-sm text-gray-500">
										<Minus /> supprimer l'opération complémentaire
									</div>
								)}
							</Button>
						)}
						{actionsValue.hasComplementaryActions && (
							<div className="flex flex-col gap-4">
								<p>ET</p>
								<ActionTypesDetailsContainer isComplementary />
								{actionsValue.complementaryActions.types.length > 0 && (
									<ActionBuildingTypesDetailsContainer isComplementary />
								)}
							</div>
						)}
					</>
				)}
			</div>
			{actionsValue.types.includes("RENOVATION") &&
				actionsValue.buildingType === "APPARTMENT" && (
					<ActionsSyndicSelectorContainer
						currentUserIsClient={currentUserIsClient}
						clientIsSyndic={clientIsSyndic}
					/>
				)}
			{((actionsValue.types.length > 0 && actionsValue.buildingType) ||
				commonPartsValue ||
				privateWorkValue) && <ActionBuildingDetailsContainer />}
			{["LIVING_BUILDING", "LOT_HOUSES", "MIXT_BUILDING"].includes(
				actionsValue.buildingType,
			) && <SocialLandlordRentalDetailsContainer />}
			{actionsValue.types.includes("SYNDIC") && <BuildingUsageContainer />}
			{(actionsValue.types.includes("RENOVATION") ||
				actionsValue.types.includes("EXTENSION") ||
				commonPartsValue ||
				privateWorkValue) &&
				actionsValue.buildingType && <RenovationOrExtensionDetailsContainer />}
		</div>
	);
};
export default ActionsDetailsContainer;
